module.exports = __webpack_public_path__ + "static/media/ella-color.4750be01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logos/ella-color.svg
// module id = 102
// module chunks = 0